import { styled } from '@mui/material';

export const TheRadioButton = styled('div')(() => ({
  marginRight: '8px',
}));
